import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/nl';
export const locale = {
  lang: 'nl',
  data: {
    'CONSULTA': {
      'CATALOGOS': {
        'broker': catalogos.institutos,
      },
      'TITULO': 'Enquêtes raadplegen',
      'SUBTITULO': 'Raadpleeg de informatie van de enquêtes die in een bepaalde periode op het platform zijn gegenereerd',
      'CAMPOS': {
        'anio': 'Jaar',
        'broker': 'Makelaar',
        'brokerCountry': 'Land van makelaar',
        'anioRanking': 'Jaar rangschikking',
      },
      'RESULTADOS': {
        'CARGANDO': 'Zoekresultaten laden',
        'TITULO': 'Resultaten',
        'ENCONTRADAS': 'Totaal aantal gevonden enquêtes',
        'DESCARGAR': 'Informatie downloaden in Excel-formaat',
        'SINRESULTADOS': 'Er zijn geen enquêtes gevonden die met de opgegeven parameters zijn gemaakt'
      }
    }
  }
};
